// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as LoadingDExtended } from '../../../assets/icons/extended/custom3.0/loading-d.svg?react';
import { createIcons } from '../../Icon';
const LoadingDIcon = /* @__PURE__ */ createIcons('LoadingD', {
    extended: LoadingDExtended
});
LoadingDIcon.supportedTypes = ['extended'];
LoadingDIcon.category = 'custom3.0';
export default LoadingDIcon;
